const initialState = {
    screen: 'mobile',
    type: 'mobile',
    width: 480,
};

export default function screenSize(state = initialState, action) {
    switch (action.type) {
        case 'UDATE_SCREEN_SIZE':
            var size = action.size;
            var screenType = size <= 480 ? 'mobile' : size <= 840 ? 'tablet' : 'desktop';
            return {
                ...state,
                screen: screenType,
                type: screenType,
                width: size,
            };
        default:
            return state;
    }
}
